import {useState, useEffect} from 'preact/hooks';

function MidnightCountdown({}) {
  const {hours, minutes, seconds} = useCountdownToMidnight();

  return (
    <div className="flex gap-x-1 text-deep-ocean-blue">
      <div className="flex size-8 flex-col rounded-md bg-crisp-white p-1 shadow-md md:size-9">
        <span className="text-base font-black leading-none">{hours}</span>
        <span className="text-xs leading-none">HRS</span>
      </div>
      <div className="flex items-center text-xl font-black text-crisp-white drop-shadow">
        :
      </div>
      <div className="flex size-8 flex-col rounded-md bg-crisp-white p-1 shadow-md md:size-9">
        <span className="text-base font-black leading-none">{minutes}</span>
        <span className="text-xs leading-none">MIN</span>
      </div>
      <div className="flex items-center text-xl font-black text-crisp-white drop-shadow">
        :
      </div>
      <div className="flex size-8 flex-col rounded-md bg-crisp-white p-1 shadow-md md:size-9">
        <span className="text-base font-black leading-none">{seconds}</span>
        <span className="text-xs leading-none">SEC</span>
      </div>
    </div>
  );
}

export default MidnightCountdown;

type Countdown = {
  hours: number;
  minutes: number;
  seconds: number;
};

const useCountdownToMidnight = (): Countdown => {
  const calculateTimeLeft = (): Countdown => {
    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0); // Set to midnight (00:00:00 next day)

    const timeDifference = midnight.getTime() - now.getTime();

    const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
    const seconds = Math.floor((timeDifference / 1000) % 60);

    return {
      hours,
      minutes,
      seconds,
    };
  };

  const [timeLeft, setTimeLeft] = useState<Countdown>(calculateTimeLeft);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer); // Cleanup on component unmount
  }, []);

  return timeLeft;
};
